




var canvasWidth = 500;
var canvasHeight = 300;

var centerX = (canvasWidth / 2) - 75;
var centerY = canvasHeight / 2;

var centerXB = centerX + 150;



var lampShadeShape = "Conical";
var isLamp = true;
var lamporpendant = "Lamp";

var fixture = "standard";

var roundDiameter = "30";

var conicalTop = "30";
var conicalBottom = "60";

var height = "40";
var halfHeight = "20";
var hyp = 0;

var designType = "-";
var selectedDesign;
var designBlurb;
var designSummaryImageSrc;
var designSummaryImageSrc2;

var price = 0.00;
var includeDiffuser = false;
var diffuserPrice = 0.00;
var diffuserSize = " ";

var carrierSize = 20;
var carrierPrice = 0.00;
var carrierSizeLabel = " ";
var includeCarrier = false;


document.getElementsByClassName('shapeAndSizeArea')[0].style.display = 'none';
document.getElementsByClassName('picker')[0].style.display = 'none';
document.getElementsByClassName('designBanner')[0].style.display = 'none';
document.getElementsByClassName('summary')[0].style.display = 'inline-block';
document.getElementsByClassName('lineArtCanvas')[0].style.display = 'none';
document.getElementsByClassName('chooseDesign')[0].style.display = 'none';
document.getElementsByClassName('backToSize')[0].style.display = 'none';






//config Title, set to current selection.
var configTitle = document.getElementById('configTitle');
var configSub = document.getElementById('configSub');

function pendant() {
  document.getElementsByClassName('shapeAndSizeArea')[0].style.display = 'inline-block';
  document.getElementsByClassName('summary')[0].style.display = 'inline-block';
  document.getElementsByClassName('shadeCarrier')[0].style.display = 'none';
  document.getElementsByClassName('includeCarrier')[0].style.display = 'none';
  document.getElementsByClassName('shapePicker')[0].style.display = 'inline-block';
  document.getElementsByClassName('chooseDesign')[0].style.display = 'inline-block';
  document.getElementsByClassName('backToSize')[0].style.display = 'none';
  
  
  
  configTitle.innerHTML = "Pendant Lampshade Configurator";
  configSub.innerHTML ="Compatible with B22 & E27 Fittings";
  
  lampShadeShape = document.getElementById('shape').value;
  
  isLamp = false; 
  lamporpendant = "Pendant";
  
  
  updateShade();
}

function floor() {
  document.getElementsByClassName('shapeAndSizeArea')[0].style.display = 'inline-block';
  document.getElementsByClassName('summary')[0].style.display = 'inline-block';
  document.getElementsByClassName('shadeCarrier')[0].style.display = 'none';
  document.getElementsByClassName('includeCarrier')[0].style.display = 'none';
  document.getElementsByClassName('shapePicker')[0].style.display = 'inline-block';
  document.getElementsByClassName('chooseDesign')[0].style.display = 'inline-block';
  document.getElementsByClassName('backToSize')[0].style.display = 'none';
   
  configTitle.innerHTML = "Floor / Table Lampshade Configurator";
  configSub.innerHTML ="Compatible with B22 & E27 Fittings";
  
  lampShadeShape = document.getElementById('shape').value;
  
  isLamp = true; 
  lamporpendant = "Lamp";
  updateShade();
}

function duplex() {
  document.getElementsByClassName('shapeAndSizeArea')[0].style.display = 'inline-block';
  document.getElementsByClassName('summary')[0].style.display = 'inline-block';
  document.getElementsByClassName('shadeCarrier')[0].style.display = 'inline-block';
  document.getElementsByClassName('shapePicker')[0].style.display = 'none';
  document.getElementsByClassName('chooseDesign')[0].style.display = 'inline-block';
  document.getElementsByClassName('backToSize')[0].style.display = 'none';
  
  configTitle.innerHTML = "Duplex Lampshade Configurator";
  configSub.innerHTML ="Compatible with B22 & E27 Fittings";
  
  lampShadeShape = "Duplex";
  lamporpendant = "Lamp";
  isLamp = true;
  
  updateShade();
}

function tiered() {
  document.getElementsByClassName('shapeAndSizeArea')[0].style.display = 'inline-block';
  document.getElementsByClassName('summary')[0].style.display = 'inline-block';
  
  configTitle.innerHTML = "Tiered Lampshade Configurator";
  
  document.getElementsByClassName('conicalTopDiameter')[0].style.display = 'none';
  document.getElementsByClassName('conicalBottomDiameter')[0].style.display = 'none';
  document.getElementsByClassName('shapePicker')[0].style.display = 'none';
  document.getElementsByClassName('roundDiameter')[0].style.display = 'none';
  
  document.getElementsByClassName('shadeCarrier')[0].style.display = 'none';
  document.getElementsByClassName('ovalSizes')[0].style.display = 'none';
  document.getElementsByClassName('height')[0].style.display = 'none';
  
 
  updateShade();
  
}



function shadeCarrierChange(value) {
  
  carrierSize = value * 2;
  
 updateShade(); 
}

//Carrier
function includeCarrierChanged(value) {
  var carrierChecked = document.getElementById('carrier').checked;
  if (carrierChecked == true){
    includeCarrier = true;
  }else {
    includeCarrier = false;
  }
  
  updateShade();
}


function pickDesign() {
  document.getElementsByClassName('shapeAndSizeArea')[0].style.display = 'inline-block';
  document.getElementsByClassName('picker')[0].style.display = 'inline-block';
  document.getElementsByClassName('backToSize')[0].style.display = 'none';
  document.getElementsByClassName('chooseDesign')[0].style.display = 'inline-block';
}

function backToSize() {
  document.getElementsByClassName('shapeAndSizeArea')[0].style.display = 'inline-block';
  document.getElementsByClassName('picker')[0].style.display = 'inline-block';
  document.getElementsByClassName('backToSize')[0].style.display = 'none';
  document.getElementsByClassName('chooseDesign')[0].style.display = 'inline-block';
}

function shapeChange(value) {
  lampShadeShape = value;
  updateShade();
}


//SLIDER
var slider = document.getElementById("heightSlider");
var output = document.getElementById("heightRangeLabel");
output.innerHTML = slider.value; // Display the default slider value

// Update the current slider value (each time you drag the slider handle)
slider.oninput = function() {
  height = this.value * 2;
  halfHeight = this.value;
  output.innerHTML = this.value + "cm";
  updateShade();
}

function lampOrPendantChange(value) {
  
  if (value == "lamp") {
   	isLamp = true; 
    lamporpendant = "Lamp";
  } else {
    isLamp = false; 
    lamporpendant = "Pendant";
  }
  
  updateShade();
}

function roundDiameterChange(value) {
  roundDiameter = value * 2;
  
  if (roundDiameter == "200") {
    centerX = (canvasWidth / 2) - 100;
   	centerXB = centerX + 220; 
  } else {
    centerX = (canvasWidth / 2) - 75;
   	centerXB = centerX + 150; 
  }
  updateShade();
}

function conicalTopDiameterChange(value) {
  conicalTop = value * 2;
  updateShade();
}

function conicalBottomDiameterChange(value) {
  conicalBottom = value * 2;
  updateShade();
}



var designSelectedEMAIL = document.getElementById('designSelected');

function swatchChanged(value) {
	selectedDesign = document.querySelector('input[name=swatch]:checked');
  
  
    if(selectedDesign != null) { 
       designSelectedEMAIL.value = selectedDesign.value;
    
       updateDesign(selectedDesign.value);
    }
}




//DIFFUSER
function diffuserChanged(value) {
   var diffuserChecked = document.getElementById('diffuser').checked;
   
   if (diffuserChecked == true) {
     includeDiffuser = true;
   } else {
    includeDiffuser = false; 
   }
  
  updateShade();
}



function updateShade() {
 	
  //Update Side and Top View, Pricing etc. 
  document.getElementsByClassName('roundDiameter')[0].style.display = 'none';
  //document.getElementsByClassName('height')[0].style.display = 'none';
  document.getElementsByClassName('ovalSizes')[0].style.display = 'none';
  document.getElementsByClassName('conicalTopDiameter')[0].style.display = 'none';
  document.getElementsByClassName('conicalBottomDiameter')[0].style.display = 'none';
  //document.getElementsByClassName('lampOrPendant')[0].style.display = 'none';
  document.getElementsByClassName('diffuserPicker')[0].style.display = 'none';
  document.getElementsByClassName('summaryText')[0].style.display = 'none';
  document.getElementsByClassName('lineArtCanvas')[0].style.display = 'none';
  //document.getElementsByClassName('lineArtCanvasLower')[0].style.display = 'none';
  

  updateSideView();

  updateSummary();
}

function updateSideView() {
  var sideViewCanvas = document.getElementById("sideView");
  var contextSV = sideViewCanvas.getContext("2d");
  contextSV.clearRect(0, 0, canvasWidth, canvasHeight);
  
  
  //var cartViewCanvas = document.getElementById("cartView");
  //var contextCart = cartViewCanvas.getContext("2d");
  //contextCart.clearRect(0, 0, canvasWidth, canvasHeight);
  //contextCart.scale(0.25, 0.25);
  
  
  
  //top view Round/Drum
  if (lampShadeShape == "Round") { 
    document.getElementsByClassName('roundDiameter')[0].style.display = 'inline-block';
    document.getElementsByClassName('height')[0].style.display = 'inline-block';
    //document.getElementsByClassName('lampOrPendant')[0].style.display = 'inline-block';
    document.getElementsByClassName('summaryText')[0].style.display = 'inline-block';
    document.getElementsByClassName('lineArtCanvas')[0].style.display = 'inline-block';
    //document.getElementsByClassName('lineArtCanvasLower')[0].style.display = 'inline-block';
    
    
    //draw fixture
      var tempD = roundDiameter / 2;

      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.lineTo(centerXB + tempD * Math.cos(0), centerY + tempD * Math.sin(0));
      contextSV.closePath();
      contextSV.stroke();

      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.lineTo(centerXB + tempD * Math.cos(-90), centerY + tempD * Math.sin(90));
      contextSV.closePath();
      contextSV.stroke();

      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.lineTo(centerXB + tempD * Math.cos(-180), centerY + tempD * Math.sin(180));
      contextSV.closePath();

      contextSV.stroke();

      if (roundDiameter == "200") {

        contextSV.beginPath();
        contextSV.moveTo(centerXB, centerY);
        contextSV.lineTo(centerXB + tempD * Math.cos(-45), centerY + tempD * Math.sin(45));
        contextSV.closePath();   
        contextSV.stroke();

        contextSV.beginPath();
        contextSV.moveTo(centerXB, centerY);
        contextSV.lineTo(centerXB - tempD , centerY);
        contextSV.closePath();
        contextSV.stroke();

        contextSV.beginPath();
        contextSV.moveTo(centerXB, centerY);
        contextSV.lineTo(centerXB + tempD * Math.cos(45), centerY + tempD * Math.sin(-45));
        contextSV.closePath();
        contextSV.stroke();
      }
    
    
    if (fixture == "duplex") {
      //Main Diameter Circle - Standard Frame
      contextSV.beginPath();
      contextSV.arc(centerXB, centerY, roundDiameter / 2, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.stroke();
      
      //hub ring - standard Frame
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.arc(centerXB, centerY, 11.3, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.stroke();
      contextSV.fillStyle = "white";
      contextSV.fill();
      
    }else {
      
      
    	//Main Diameter Circle - Standard Frame
      contextSV.beginPath();
      contextSV.arc(centerXB, centerY, roundDiameter / 2, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.stroke();

      //hub ring - standard Frame
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.arc(centerXB, centerY, 5, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.stroke();
      contextSV.fillStyle = "white";
      contextSV.fill();
    }
    
    
  }
  
  //Side View Round/Drum
  if (lampShadeShape == "Round") {
    
    //Draw standard fitting
    //if lamp
    if (isLamp == true) {
      
      if (fixture == "duplex") {
        contextSV.beginPath();

        contextSV.moveTo(centerX - (roundDiameter / 2), (centerY + 8) - height);
        contextSV.lineTo(centerX - 11.3, (centerY + 19) - height);
        contextSV.lineTo(centerX + 11.3, (centerY + 19) - height);
        contextSV.lineTo(centerX + (roundDiameter / 2), (centerY + 8) - height);

        contextSV.stroke();
        
      }else{
        contextSV.beginPath();

        contextSV.moveTo(centerX - (roundDiameter / 2), centerY + 8);
        contextSV.lineTo(centerX - 5, centerY);
        contextSV.lineTo(centerX + 5, centerY);
        contextSV.lineTo(centerX + (roundDiameter / 2), centerY + 8);
        
        contextSV.stroke();
        
        //draw bulb and pendant holder
        contextSV.beginPath();
        contextSV.moveTo(centerX + 2, (centerY - 10) + 15);
        contextSV.lineTo(centerX + 2, (centerY - 17) + 15);
        contextSV.lineTo(centerX + 4, (centerY - 22) + 15);
        contextSV.lineTo(centerX + 5, (centerY - 26) + 15);
        contextSV.lineTo(centerX + 0, (centerY - 28) + 15);
        contextSV.lineTo(centerX - 5, (centerY - 26) + 15);
        contextSV.lineTo(centerX - 4, (centerY - 22) + 15);
        contextSV.lineTo(centerX - 2, (centerY - 17) + 15);
        contextSV.lineTo(centerX - 2, (centerY - 10) + 15);
        contextSV.lineTo(centerX + 2, (centerY - 10) + 15);
        
        contextSV.moveTo(centerX - 4, (centerY - 20) + 15);
        contextSV.lineTo(centerX + 4, (centerY - 20) + 15);
        
        contextSV.moveTo(centerX + 2, (centerY - 10) + 15);
        contextSV.lineTo(centerX + 4, (centerY - 10) + 15);
        contextSV.lineTo(centerX + 4, (centerY + 30) + 15);
        
        contextSV.moveTo(centerX - 4, (centerY + 30) + 15);
        contextSV.lineTo(centerX - 4, (centerY - 10) + 15);
        contextSV.lineTo(centerX - 2, (centerY - 10) + 15);

        contextSV.strokeStyle = "#8f8f8d";
        contextSV.stroke();
        
      }

    }
    //if pendant
    if (isLamp == false) {
      contextSV.beginPath();

      contextSV.moveTo(centerX - (roundDiameter / 2), (centerY + 8) - height);
      contextSV.lineTo(centerX - 5, (centerY + 16) - height);
      contextSV.lineTo(centerX + 5, (centerY + 16) - height);
      contextSV.lineTo(centerX + (roundDiameter / 2), (centerY + 8) - height);
      contextSV.strokeStyle = "#000000";
      contextSV.stroke();
      
      //draw bulb and pendant holder
      contextSV.beginPath();
	  contextSV.moveTo(centerX - 2, (centerY + 10) - height);
      contextSV.lineTo(centerX - 2, (centerY + 17) - height);
      contextSV.lineTo(centerX - 4, (centerY + 22) - height);
      contextSV.lineTo(centerX - 5, (centerY + 26) - height);
      contextSV.lineTo(centerX - 0, (centerY + 28) - height);
      contextSV.lineTo(centerX + 5, (centerY + 26) - height);
      contextSV.lineTo(centerX + 4, (centerY + 22) - height);
      contextSV.lineTo(centerX + 2, (centerY + 17) - height);
      contextSV.lineTo(centerX + 2, (centerY + 10) - height);
      contextSV.lineTo(centerX - 2, (centerY + 10) - height);
      
      contextSV.moveTo(centerX + 4, (centerY + 20) - height);
      contextSV.lineTo(centerX - 4, (centerY + 20) - height);
      
      contextSV.moveTo(centerX - 0.5, (centerY + 10) - height);
      contextSV.lineTo(centerX - 0.5, (centerY - 120) - height);
      contextSV.lineTo(centerX + 0.5, (centerY - 120) - height);
      contextSV.lineTo(centerX + 0.5, (centerY + 10) - height);
      
      contextSV.strokeStyle = "#8f8f8d";
      contextSV.stroke();
    }
    
    contextSV.beginPath();

    contextSV.moveTo(centerX + (roundDiameter / 2), centerY + 8);

    contextSV.lineTo(centerX + (roundDiameter / 2), (centerY + 8) - height);
    contextSV.lineTo(centerX - (roundDiameter / 2), (centerY + 8) - height);
    contextSV.lineTo(centerX - (roundDiameter / 2), centerY + 8);
    contextSV.lineTo(centerX + (roundDiameter / 2), centerY + 8);
    contextSV.strokeStyle = "#000000";
    contextSV.stroke();
    
    
  }
  
  // Draw Side View Conical
  if(lampShadeShape == "Conical") {
   
    //Draw fitting
    //if lamp
    if (isLamp == true) {
      contextSV.beginPath();

      contextSV.moveTo(centerX - (conicalBottom / 2), centerY + 8);
      contextSV.lineTo(centerX - 5, centerY);
      contextSV.lineTo(centerX + 5, centerY);
      contextSV.lineTo(centerX + (conicalBottom / 2), centerY + 8);
	  contextSV.strokeStyle = "#000000";
      contextSV.stroke();
      
      //draw bulb and lamp holder
        contextSV.beginPath();
        contextSV.moveTo(centerX + 2, (centerY - 10) + 15);
        contextSV.lineTo(centerX + 2, (centerY - 17) + 15);
        contextSV.lineTo(centerX + 4, (centerY - 22) + 15);
        contextSV.lineTo(centerX + 5, (centerY - 26) + 15);
        contextSV.lineTo(centerX + 0, (centerY - 28) + 15);
        contextSV.lineTo(centerX - 5, (centerY - 26) + 15);
        contextSV.lineTo(centerX - 4, (centerY - 22) + 15);
        contextSV.lineTo(centerX - 2, (centerY - 17) + 15);
        contextSV.lineTo(centerX - 2, (centerY - 10) + 15);
        contextSV.lineTo(centerX + 2, (centerY - 10) + 15);
        
        contextSV.moveTo(centerX - 4, (centerY - 20) + 15);
        contextSV.lineTo(centerX + 4, (centerY - 20) + 15);
        
        contextSV.moveTo(centerX + 2, (centerY - 10) + 15);
        contextSV.lineTo(centerX + 4, (centerY - 10) + 15);
        contextSV.lineTo(centerX + 4, (centerY + 30) + 15);
        
        contextSV.moveTo(centerX - 4, (centerY + 30) + 15);
        contextSV.lineTo(centerX - 4, (centerY - 10) + 15);
        contextSV.lineTo(centerX - 2, (centerY - 10) + 15);

        contextSV.strokeStyle = "#8f8f8d";
        contextSV.stroke();

    }
    
    //if pendant
    if (isLamp == false) {
      contextSV.beginPath();
      
	  contextSV.moveTo(centerX - (conicalTop / 2), (centerY + 8) - height);
      contextSV.lineTo(centerX - 5, (centerY + 16) - height);
      contextSV.lineTo(centerX + 5, (centerY + 16) - height);
      contextSV.lineTo(centerX + (conicalTop / 2), (centerY + 8) - height);
      contextSV.strokeStyle = "#000000";
      contextSV.stroke();
      
      //draw bulb and pendant holder
      contextSV.beginPath();
	  contextSV.moveTo(centerX - 2, (centerY + 10) - height);
      contextSV.lineTo(centerX - 2, (centerY + 17) - height);
      contextSV.lineTo(centerX - 4, (centerY + 22) - height);
      contextSV.lineTo(centerX - 5, (centerY + 26) - height);
      contextSV.lineTo(centerX - 0, (centerY + 28) - height);
      contextSV.lineTo(centerX + 5, (centerY + 26) - height);
      contextSV.lineTo(centerX + 4, (centerY + 22) - height);
      contextSV.lineTo(centerX + 2, (centerY + 17) - height);
      contextSV.lineTo(centerX + 2, (centerY + 10) - height);
      contextSV.lineTo(centerX - 2, (centerY + 10) - height);
      
      contextSV.moveTo(centerX + 4, (centerY + 20) - height);
      contextSV.lineTo(centerX - 4, (centerY + 20) - height);
      
      contextSV.moveTo(centerX - 0.5, (centerY + 10) - height);
      contextSV.lineTo(centerX - 0.5, (centerY - 120) - height);
      contextSV.lineTo(centerX + 0.5, (centerY - 120) - height);
      contextSV.lineTo(centerX + 0.5, (centerY + 10) - height);
      
      contextSV.strokeStyle = "#8f8f8d";
      contextSV.stroke();
      
    }
    
    
    contextSV.beginPath();
    
    //bottom frame - lower left
    contextSV.moveTo(centerX - (conicalBottom / 2), centerY + 8);
    //lower right
    contextSV.lineTo(centerX + (conicalBottom / 2), centerY + 8);
    
    //right side
    contextSV.lineTo(centerX + (conicalTop / 2), (centerY + 8) - height);
    
    //top frame
    contextSV.lineTo(centerX - (conicalTop / 2), (centerY + 8) - height);
    contextSV.strokeStyle = "#000000";
    contextSV.stroke();
    
    //left side
    contextSV.beginPath();
    contextSV.moveTo(centerX - (conicalTop / 2), (centerY + 8) - height);
    contextSV.lineTo(centerX - (conicalBottom / 2), centerY + 8);
    contextSV.strokeStyle = "#0000FF";
  	contextSV.stroke();
  	contextSV.closePath();
    
    contextSV.strokeStyle = "#000000";
    
    
    
  }
  
  //Draw Top View Conical
  if (lampShadeShape == "Conical") { 
    document.getElementsByClassName('conicalTopDiameter')[0].style.display = 'inline-block';
    document.getElementsByClassName('conicalBottomDiameter')[0].style.display = 'inline-block';
    document.getElementsByClassName('height')[0].style.display = 'inline-block';
    //document.getElementsByClassName('lampOrPendant')[0].style.display = 'inline-block';
    document.getElementsByClassName('summaryText')[0].style.display = 'inline-block';
    document.getElementsByClassName('lineArtCanvas')[0].style.display = 'inline-block';
    //document.getElementsByClassName('lineArtCanvasLower')[0].style.display = 'inline-block';
    
    //draw fixture
   
      //fill area of shade to cover frame error.. also find out whats drawing it...
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.arc(centerXB, centerY, conicalBottom / 2, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.fillStyle = "rgba(50, 50, 50, 0.1)";
	  contextSV.fill();
      
      
      
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.arc(centerXB, centerY, conicalTop / 2, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.fillStyle = "white";
	  contextSV.fill();
      
      
      //Frame Struts
      var tempD = conicalTop / 2;
    
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.lineTo(centerXB + tempD * Math.cos(0), centerY + tempD * Math.sin(0));
      contextSV.closePath();
	  contextSV.stroke();
      
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.lineTo(centerXB + tempD * Math.cos(-90), centerY + tempD * Math.sin(90));
      contextSV.closePath();
	  contextSV.stroke();
      
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.lineTo(centerXB + tempD * Math.cos(-180), centerY + tempD * Math.sin(180));
      contextSV.closePath();
      contextSV.stroke();
      
      //Bottom Diameter Circle
      contextSV.beginPath();
      //context.moveTo(centerX, centerY);
      contextSV.arc(centerXB, centerY, conicalBottom / 2, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.stroke();

      //Top Diameter Circle
      contextSV.beginPath();
      //context.moveTo(centerX, centerY);
      contextSV.arc(centerXB, centerY, conicalTop / 2, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.stroke();

      //hub ring
      contextSV.beginPath();
      //context.moveTo(centerX, centerY);
      contextSV.arc(centerXB, centerY, 5, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.stroke();
      contextSV.fillStyle = "white";
      contextSV.fill();
      
    
      
  }
  
  // Draw top view Duplex
  if(lampShadeShape == "Duplex") {
    document.getElementsByClassName('conicalTopDiameter')[0].style.display = 'inline-block';
    document.getElementsByClassName('conicalBottomDiameter')[0].style.display = 'inline-block';
    document.getElementsByClassName('height')[0].style.display = 'inline-block';
    document.getElementsByClassName('lineArtCanvas')[0].style.display = 'inline-block';
    document.getElementsByClassName('summaryText')[0].style.display = 'inline-block';
    
     var tempD = conicalBottom / 2;
     
      //fill area of shade to cover frame error.. also find out whats drawing it...
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.arc(centerXB, centerY, conicalBottom / 2, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.fillStyle = "rgba(50, 50, 50, 0.1)";
	  contextSV.fill();
      
      
      
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.arc(centerXB, centerY, conicalTop / 2, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.fillStyle = "white";
	  contextSV.fill();
      
      
      //Frame Struts
      var tempD = conicalTop / 2;
    
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.lineTo(centerXB + tempD * Math.cos(0), centerY + tempD * Math.sin(0));
      contextSV.closePath();
	  contextSV.stroke();
      
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.lineTo(centerXB + tempD * Math.cos(-90), centerY + tempD * Math.sin(90));
      contextSV.closePath();
	  contextSV.stroke();
      
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.lineTo(centerXB + tempD * Math.cos(-180), centerY + tempD * Math.sin(180));
      contextSV.closePath();
      contextSV.stroke();
      
      //Bottom Diameter Circle
      contextSV.beginPath();
      //context.moveTo(centerX, centerY);
      contextSV.arc(centerXB, centerY, conicalBottom / 2, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.stroke();

      //Top Diameter Circle
      contextSV.beginPath();
      //context.moveTo(centerX, centerY);
      contextSV.arc(centerXB, centerY, conicalTop / 2, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.stroke();

      //hub ring
      contextSV.beginPath();
      //context.moveTo(centerX, centerY);
      contextSV.arc(centerXB, centerY, 5, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.stroke();
      contextSV.fillStyle = "white";
      contextSV.fill();
      
      //hub ring - standard Frame
      contextSV.beginPath();
      contextSV.moveTo(centerXB, centerY);
      contextSV.arc(centerXB, centerY, 11.3, 0, 2 * Math.PI);
      contextSV.closePath();
      contextSV.stroke();
      contextSV.fillStyle = "white";
      contextSV.fill();
  }
  
   // Draw Side View Duplex
  if(lampShadeShape == "Duplex") {
   
    contextSV.beginPath();

    contextSV.moveTo(centerX - (conicalTop / 2), (centerY + 8) - height);
    contextSV.lineTo(centerX - 11.3, (centerY + 19) - height);
    contextSV.lineTo(centerX + 11.3, (centerY + 19) - height);
    contextSV.lineTo(centerX + (conicalTop / 2), (centerY + 8) - height);

    contextSV.stroke();
    
    
    contextSV.beginPath();
    
    //bottom frame - lower left
    contextSV.moveTo(centerX - (conicalBottom / 2), centerY + 8);
    //lower right
    contextSV.lineTo(centerX + (conicalBottom / 2), centerY + 8);
    
    //right side
    contextSV.lineTo(centerX + (conicalTop / 2), (centerY + 8) - height);
    
    //top frame
    contextSV.lineTo(centerX - (conicalTop / 2), (centerY + 8) - height);
    contextSV.strokeStyle = "#000000";
    contextSV.stroke();
    
    //left side
    contextSV.beginPath();
    contextSV.moveTo(centerX - (conicalTop / 2), (centerY + 8) - height);
    contextSV.lineTo(centerX - (conicalBottom / 2), centerY + 8);
    contextSV.strokeStyle = "#0000FF";
  	contextSV.stroke();
  	contextSV.closePath();
    
    contextSV.strokeStyle = "#000000";
    
  //Draw shade Carrier
    // get size selected
    
 
    contextSV.beginPath();
    contextSV.moveTo(centerX - 11.3, (centerY + 16) - height);
    contextSV.lineTo(centerX - 11.3, (centerY + 19) - height);
    contextSV.lineTo(centerX - 5.8, ((19 + carrierSize) + centerY) - height);
    contextSV.lineTo(centerX + 5.8, ((19 + carrierSize) + centerY) - height);
    contextSV.lineTo(centerX + 11.3, (centerY + 19) - height);
    contextSV.lineTo(centerX + 11.3, (centerY + 16) - height);
    
    bottomOfShadeCarrier = ((19 + carrierSize) + centerY) - height;
    
    contextSV.strokeStyle = "#800080";
    contextSV.stroke();
  	contextSV.closePath();
    
    //draw bulb and Lamp holder
        contextSV.beginPath();
        contextSV.moveTo(centerX + 2, (bottomOfShadeCarrier - 10) + 15);
        contextSV.lineTo(centerX + 2, (bottomOfShadeCarrier - 17) + 15);
        contextSV.lineTo(centerX + 4, (bottomOfShadeCarrier - 22) + 15);
        contextSV.lineTo(centerX + 5, (bottomOfShadeCarrier - 26) + 15);
        contextSV.lineTo(centerX + 0, (bottomOfShadeCarrier - 28) + 15);
        contextSV.lineTo(centerX - 5, (bottomOfShadeCarrier - 26) + 15);
        contextSV.lineTo(centerX - 4, (bottomOfShadeCarrier - 22) + 15);
        contextSV.lineTo(centerX - 2, (bottomOfShadeCarrier - 17) + 15);
        contextSV.lineTo(centerX - 2, (bottomOfShadeCarrier - 10) + 15);
        contextSV.lineTo(centerX + 2, (bottomOfShadeCarrier - 10) + 15);
        
        contextSV.moveTo(centerX - 4, (bottomOfShadeCarrier - 20) + 15);
        contextSV.lineTo(centerX + 4, (bottomOfShadeCarrier - 20) + 15);
        
        contextSV.moveTo(centerX + 2, (bottomOfShadeCarrier - 10) + 15);
        contextSV.lineTo(centerX + 4, (bottomOfShadeCarrier - 10) + 15);
        contextSV.lineTo(centerX + 4, (bottomOfShadeCarrier + 60) + 15);
        
        contextSV.moveTo(centerX - 4, (bottomOfShadeCarrier + 60) + 15);
        contextSV.lineTo(centerX - 4, (bottomOfShadeCarrier - 10) + 15);
        contextSV.lineTo(centerX - 2, (bottomOfShadeCarrier - 10) + 15);

        contextSV.strokeStyle = "#8f8f8d";
        contextSV.stroke();
    
    contextSV.strokeStyle = "#000000";
  }
  
  if (lampShadeShape == "Oval") {
    document.getElementsByClassName('ovalSizes')[0].style.display = 'inline-block';
    document.getElementsByClassName('height')[0].style.display = 'inline-block';
    //document.getElementsByClassName('lampOrPendant')[0].style.display = 'inline-block';
    
   
    contextSV.beginPath();
	for (var i = 0 * Math.PI; i < 2 * Math.PI; i += 0.01 ) {
    	xPos = centerXB - (ovalDepth * Math.sin(i)) * Math.sin(0 * Math.PI) + (ovalWidth * Math.cos(i)) * Math.cos(0 * Math.PI);
    	yPos = centerY + (ovalWidth * Math.cos(i)) * Math.sin(0 * Math.PI) + (ovalDepth * Math.sin(i)) * Math.cos(0 * Math.PI);

    	if (i == 0) {
       	 contextSV.moveTo(xPos, yPos);
    	} else {
      	  contextSV.lineTo(xPos, yPos);
   		 }
	}
    contextSV.closePath();
	contextSV.stroke();
  }
  
  if(lampShadeShape == "Oval" ) {
    
  }
  

//PRICE  /////////////////////////////////////////////////// 

  //ROUND PRICING
  if (lampShadeShape == "Round") {
    if ((roundDiameter / 2) == 10) {
          price = 17.95;
    }
    if ((roundDiameter / 2) == 15) {
          price = 19.95;
    }
    if ((roundDiameter / 2) == 20) {
          price = 24.95;
    }
    if ((roundDiameter / 2) == 25) {
          price = 29.95;
    }
    if ((roundDiameter / 2) == 30) {
          price = 34.95;
    }
    if ((roundDiameter / 2) == 35) {
          price = 44.95;
    }
    if ((roundDiameter / 2) == 40) {
          price = 54.95;
    }
    if ((roundDiameter / 2) == 45) {
          price = 64.95;
    }
    if ((roundDiameter / 2) == 50) {
          price = 74.95;
    }
    if ((roundDiameter / 2) == 60) {
          price = 109.95;
    }
    if ((roundDiameter / 2) == 70) {
          price = 129.95;
    }
    if ((roundDiameter / 2) == 100) {
          price = 249.95;
    }
  }
  
  //CONICAL PRICING
  if (lampShadeShape == "Conical") {
    
    if (conicalBottom > conicalTop) {
      
      if ((conicalBottom / 2) == 15) {
          price = 19.95;
      }
      if ((conicalBottom / 2) == 20) {
            price = 24.95;
      }
      if ((conicalBottom / 2) == 25) {
            price = 29.95;
      }
      if ((conicalBottom / 2) == 30) {
            price = 34.95;
      }
      if ((conicalBottom / 2) == 35) {
            price = 44.95;
      }
      if ((conicalBottom / 2) == 40) {
            price = 54.95;
      }
      if ((conicalBottom / 2) == 45) {
            price = 64.95;
      }
      if ((conicalBottom / 2) == 50) {
            price = 74.95;
      }
      if ((conicalBottom / 2) == 60) {
            price = 109.95;
      }
      if ((conicalBottom / 2) == 70) {
            price = 129.95;
      }
    
    } else {  
      if ((conicalTop / 2) == 15) {
          price = 19.95;
      }
      if ((conicalTop / 2) == 20) {
            price = 24.95;
      }
      if ((conicalTop / 2) == 25) {
            price = 29.95;
      }
      if ((conicalTop / 2) == 30) {
            price = 34.95;
      }
      if ((conicalTop / 2) == 35) {
            price = 44.95;
      }
      if ((conicalTop / 2) == 40) {
            price = 54.95;
      }
      if ((conicalTop / 2) == 45) {
            price = 64.95;
      }
      if ((conicalTop / 2) == 50) {
            price = 74.95;
      }
    }
    
    
  }
  
   //DUPLEX PRICING
  if (lampShadeShape == "Duplex") {
    
    if (conicalBottom > conicalTop) {
      
      if ((conicalBottom / 2) == 15) {
          price = 19.95;
      }
      if ((conicalBottom / 2) == 20) {
            price = 24.95;
      }
      if ((conicalBottom / 2) == 25) {
            price = 29.95;
      }
      if ((conicalBottom / 2) == 30) {
            price = 34.95;
      }
      if ((conicalBottom / 2) == 35) {
            price = 44.95;
      }
      if ((conicalBottom / 2) == 40) {
            price = 54.95;
      }
      if ((conicalBottom / 2) == 45) {
            price = 64.95;
      }
      if ((conicalBottom / 2) == 50) {
            price = 74.95;
      }
      if ((conicalBottom / 2) == 60) {
            price = 109.95;
      }
      if ((conicalBottom / 2) == 70) {
            price = 129.95;
      }
    
    } else {  
      if ((conicalTop / 2) == 15) {
          price = 19.95;
      }
      if ((conicalTop / 2) == 20) {
            price = 24.95;
      }
      if ((conicalTop / 2) == 25) {
            price = 29.95;
      }
      if ((conicalTop / 2) == 30) {
            price = 34.95;
      }
      if ((conicalTop / 2) == 35) {
            price = 44.95;
      }
      if ((conicalTop / 2) == 40) {
            price = 54.95;
      }
      if ((conicalTop / 2) == 45) {
            price = 64.95;
      }
      if ((conicalTop / 2) == 50) {
            price = 74.95;
      }
    }
    
    
  }
  
  
  //ROUND ~ Adjust based on height
  if (lampShadeShape == "Round") {
    var tempHeight = height / 2;
    var tempDia = roundDiameter / 2;
    if (tempHeight >= 15 && tempHeight <= 30) {
      	
      if (tempDia >= 10 && tempDia <= 25){
          price = price + ((tempHeight - 20) * 0.5);
        
      }
      if (tempDia >= 30 && tempDia <= 50){
          price = price + ((tempHeight - 20) * 1);
        
      }
      if (tempDia >= 60 && tempDia <= 100){
          price = price + ((tempHeight - 20) * 1.5);
        
      }
    }
    if (tempHeight >= 31 && tempHeight <= 65) {
      	
      if (tempDia >= 10 && tempDia <= 25){
          price = price + ((tempHeight - 20) * 1.0);
        
      }
      if (tempDia >= 30 && tempDia <= 50){
          price = price + ((tempHeight - 20) * 1.5);
        
      }
      if (tempDia >= 60 && tempDia <= 100){
          price = price + ((tempHeight - 20) * 2.0);
        
      }
    }
  }
  
  //CONICAL ~ Adjust based on height
  if (lampShadeShape == "Conical") {
    
    var tempHeight = height / 2;
    var tempDia;
    
    if (conicalBottom > conicalTop) {
      tempDia = conicalBottom / 2;
    } else {
      tempDia = conicalTop / 2;
    }
    
    
    if (tempHeight >= 15 && tempHeight <= 30) {
      	
      if (tempDia >= 10 && tempDia <= 25){
          price = price + ((tempHeight - 20) * 0.5);
        
      }
      if (tempDia >= 30 && tempDia <= 50){
          price = price + ((tempHeight - 20) * 1);
        
      }
      if (tempDia >= 60 && tempDia <= 100){
          price = price + ((tempHeight - 20) * 1.5);
        
      }
    }
    if (tempHeight >= 31 && tempHeight <= 65) {
      	
      if (tempDia >= 10 && tempDia <= 25){
          price = price + ((tempHeight - 20) * 1.0);
        
      }
      if (tempDia >= 30 && tempDia <= 50){
          price = price + ((tempHeight - 20) * 1.5);
        
      }
      if (tempDia >= 60 && tempDia <= 100){
          price = price + ((tempHeight - 20) * 2.0);
        
      }
    }
  }
  
  //DUPLEX ~ Adjust based on height
  if (lampShadeShape == "Duplex") {
    
    var tempHeight = height / 2;
    var tempDia;
    
    if (conicalBottom > conicalTop) {
      tempDia = conicalBottom / 2;
    } else {
      tempDia = conicalTop / 2;
    }
    
    
    if (tempHeight >= 15 && tempHeight <= 30) {
      	
      if (tempDia >= 10 && tempDia <= 25){
          price = price + ((tempHeight - 20) * 0.5);
        
      }
      if (tempDia >= 30 && tempDia <= 50){
          price = price + ((tempHeight - 20) * 1);
        
      }
      if (tempDia >= 60 && tempDia <= 100){
          price = price + ((tempHeight - 20) * 1.5);
        
      }
    }
    if (tempHeight >= 31 && tempHeight <= 65) {
      	
      if (tempDia >= 10 && tempDia <= 25){
          price = price + ((tempHeight - 20) * 1.0);
        
      }
      if (tempDia >= 30 && tempDia <= 50){
          price = price + ((tempHeight - 20) * 1.5);
        
      }
      if (tempDia >= 60 && tempDia <= 100){
          price = price + ((tempHeight - 20) * 2.0);
        
      }
    }
  }
  
  
  //DIFFUSER IF PENDANT
  if (lamporpendant == "Pendant") {
    
    var tempDiffuserSize;
    
    var diffuserLabel = document.getElementById('diffuserLabel');
    
    if (lampShadeShape == "Round") {
      tempDiffuserSize = roundDiameter / 2;
      
      if (tempDiffuserSize == 10) {
          diffuserPrice = 2.50;
          diffuserSize = "10 cm";
      }
      if (tempDiffuserSize == 15) {
        diffuserPrice = 2.75;
        diffuserSize = "15cm";
      }
      if (tempDiffuserSize == 20) {
            diffuserPrice = 3.00;
        diffuserSize = "20cm";
      }
      if (tempDiffuserSize == 25) {
            diffuserPrice = 3.50;
        diffuserSize = "25cm";
      }
      if (tempDiffuserSize == 30) {
            diffuserPrice = 5.00;
        diffuserSize = "30cm";
      }
      if (tempDiffuserSize == 35) {
            diffuserPrice = 6.50;
        diffuserSize = "35cm";
      }
      if (tempDiffuserSize == 40) {
            diffuserPrice = 9.00;
        diffuserSize = "40cm";
      }
      if (tempDiffuserSize == 45) {
            diffuserPrice = 10.00;
        diffuserSize = "45cm";
      }
      if (tempDiffuserSize == 50) {
            diffuserPrice = 13.00;
        diffuserSize = "50cm";
      }
      if (tempDiffuserSize == 60) {
            diffuserPrice = 15.00;
        diffuserSize = "60cm";
      }
      if (tempDiffuserSize == 70) {
            diffuserPrice = 19.00;
        diffuserSize = "70cm";
      }
      if (tempDiffuserSize == 100) {
            diffuserPrice = 25.00;
        diffuserSize = "100cm";
      }

    }
    
    if (lampShadeShape == "Conical") {
      tempDiffuserSize = conicalBottom / 2; 
      
      if (tempDiffuserSize == 10) {
          diffuserPrice = 2.50;
        diffuserSize = "10cm";
      }
      if (tempDiffuserSize == 15) {
            diffuserPrice = 2.75;
        diffuserSize = "15cm";
      }
      if (tempDiffuserSize == 20) {
            diffuserPrice = 3.00;
        diffuserSize = "20cm";
      }
      if (tempDiffuserSize == 25) {
            diffuserPrice = 3.50;
        diffuserSize = "25cm";
      }
      if (tempDiffuserSize == 30) {
            diffuserPrice = 5.00;
        diffuserSize = "30cm";
      }
      if (tempDiffuserSize == 35) {
            diffuserPrice = 6.50;
        diffuserSize = "35cm";
      }
      if (tempDiffuserSize == 40) {
            diffuserPrice = 9.00;
        diffuserSize = "40cm";
      }
      if (tempDiffuserSize == 45) {
            diffuserPrice = 10.00;
        diffuserSize = "45cm";
      }
      if (tempDiffuserSize == 50) {
            diffuserPrice = 13.00;
        diffuserSize = "50cm";
      }
      if (tempDiffuserSize == 60) {
            diffuserPrice = 15.00;
        diffuserSize = "60cm";
      }
      if (tempDiffuserSize == 70) {
            diffuserPrice = 19.00;
        diffuserSize = "70cm";
      }
     
    }
    
    var diffuserValue = document.getElementById('diffuser');
    diffuserValue.value = diffuserPrice;
    
    diffuserLabel.innerHTML = "+ £" + diffuserPrice.toFixed(2) + ", Add a Diffuser";
    
    
    document.getElementsByClassName('diffuserPicker')[0].style.display = 'inline-block';
    
    // Set Price including a diffuser
    if (includeDiffuser == true) {
     	price = price + diffuserPrice; 
    }
    
   	
  }
  
  //Carrier if Duplex
  if (lampShadeShape == "Duplex") {
    var tempCarrierSize = carrierSize / 2;
    var carrierLabel = document.getElementById('carrierLabel');
    
    //check size of carrier
    
    if (tempCarrierSize == "10"){
      carrierPrice = 6.70;
      carrierSizeLabel = "10cm (4 inch)";
    }
    if (tempCarrierSize == "12"){
      carrierPrice = 6.90;
      carrierSizeLabel = "12cm (5 inch)";
    }
    if (tempCarrierSize == "15"){
      carrierPrice = 7.10;
      carrierSizeLabel = "15cm (6 inch)";
    }
    if (tempCarrierSize == "17"){
      carrierPrice = 7.40;
      carrierSizeLabel = "17cm (7 inch)";
    }
    if (tempCarrierSize == "20"){
      carrierPrice = 7.50;
      carrierSizeLabel = "20cm (8 inch)";
    }
    if (tempCarrierSize == "22"){
      carrierPrice = 7.70;
      carrierSizeLabel = "22cm (9 inch)";
    }
    if (tempCarrierSize == "25"){
      carrierPrice = 7.90;
      carrierSizeLabel = "25cm (10 inch)";
    }
    if (tempCarrierSize == "30"){
      carrierPrice = 10.00;
      carrierSizeLabel = "30cm (12 inch)";
    }
    
    
    carrierLabel.innerHTML = "+ £" + carrierPrice.toFixed(2) + ", include a " + carrierSizeLabel + " Shade Carrier with your order."; 
    document.getElementsByClassName('includeCarrier')[0].style.display = 'inline-block';
    
    //set price to include a shade carrier.
    if (includeCarrier == true) {
     price = price + carrierPrice; 
    }
  }
  
// DRAW LABELS   /////////////////////////////////////////////////
  
  var labelCanvas = document.getElementById("sideView");
  var labelContext = labelCanvas.getContext("2d");
  

   if (lampShadeShape == "Round") {
      
      labelContext.font = "14px Arial";
  	  labelContext.fillStyle = "#000000";
  	  labelContext.textAlign = "center";
	  if(lamporpendant == "Lamp") {
	  labelContext.fillText("Side View", centerX - 75, centerY + 20);
     } else {
       labelContext.fillText("Side View", centerX, centerY + 40);
     }
  	  labelContext.fillText("Top View", centerXB, ((centerY - 15) - (roundDiameter / 2)));
      
      var sideViewHeightLabel = "Height:" + (height / 2) + "cm ";
  	  labelContext.font = "12px Arial";
  		labelContext.fillStyle = "#FF0000";
  		labelContext.textAlign = "right";
		labelContext.fillText(sideViewHeightLabel, (centerX - (roundDiameter / 2)) - 5, centerY - (height / 2));
      
      	labelContext.font = "12px Arial";
      	labelContext.fillStyle = "#000000";
      labelContext.textAlign = "center";
     
    	var sideViewBottomFrameLabel = (roundDiameter / 2) + "cm diameter";
        if(lamporpendant == "Lamp") {
           labelContext.fillText(sideViewBottomFrameLabel, centerX, centerY - height);
        } else {
  		  labelContext.fillText(sideViewBottomFrameLabel, centerX, centerY + 28);
        }
     
      	labelContext.beginPath();
  		labelContext.moveTo((centerX - (roundDiameter / 2)) - 5, centerY + 8);
    	labelContext.lineTo((centerX - (roundDiameter / 2)) - 5, (centerY + 8) - height);
      	labelContext.strokeStyle = "#FF0000";
      
  		labelContext.stroke();
  		labelContext.closePath();
      
        labelContext.textAlign = "center";
      	labelContext.strokeStyle = "#000000";
  	}
  
   if (lampShadeShape == "Conical") {
      
      labelContext.font = "14px Arial";
  	  labelContext.fillStyle = "#000000";
  	  labelContext.textAlign = "center";
     if(lamporpendant == "Lamp") {
	  labelContext.fillText("Side View", centerX - 75, centerY + 50);
     } else {
       labelContext.fillText("Side View", centerX, centerY + 40);
     }
     
      
      if (conicalBottom > conicalTop) {
  	    labelContext.fillText("Top View", centerXB, (centerY - 15) - (conicalBottom / 2));
      }else {
        labelContext.fillText("Top View", centerXB, (centerY - 15) - (conicalTop / 2));
      }
      
      	var sideViewHeightLabel = (height / 2) + "cm";
  		labelContext.font = "12px Arial";
  		labelContext.fillStyle = "#FF0000";
  		labelContext.textAlign = "right";
		labelContext.fillText(sideViewHeightLabel, centerX - 75, (centerY + 24) - (height / 2) / 2);
        labelContext.font = "12px Arial";
  		labelContext.fillStyle = "#FF0000";
      	labelContext.textAlign = "right";
      	labelContext.fillText("Height", centerX - 75, (centerY + 36) - (height / 2) / 2);
      	
      	labelContext.font = "12px Arial";
      	labelContext.fillStyle = "#000000";
        labelContext.textAlign = "center";
     
        
     
        if(lamporpendant == "Lamp") {
          var sideViewBottomFrameLabel = (conicalBottom / 2) + "cm Bottom Diameter";
          var sideViewTopFrameLabel = (conicalTop / 2) + "cm Top Diameter";
          labelContext.fillText(sideViewTopFrameLabel, centerX, (centerY - 15) - height);
          labelContext.fillText(sideViewBottomFrameLabel, centerX, (centerY) - height);
        } else {
          var sideViewBottomFrameLabel = (conicalBottom / 2) + "cm Diameter";
          var sideViewTopFrameLabel = (conicalTop / 2) + "cm Diameter";
  		  labelContext.fillText(sideViewTopFrameLabel, centerX - 50, centerY - height);
          labelContext.fillText(sideViewBottomFrameLabel, centerX, centerY + 25);
        }
		
  		
  		
  	
      
      	//calc hypotenuse
        var a = ((conicalBottom / 2) - (conicalTop / 2)) / 2;
        var h = height / 2;
        var c = (a * a) + (h * h); 
        hyp = Math.sqrt(c);
      
		labelContext.font = "12px Arial";
  		labelContext.fillStyle = "#0000FF";
      	labelContext.textAlign = "right";
        labelContext.fillText(hyp.toFixed(2) + "cm", centerX - 75, centerY - (height / 2) / 2);
      	labelContext.fillText("Hypotenuse", centerX - 75, (centerY + 12) - (height / 2) / 2);
      
      	labelContext.beginPath();
  		labelContext.moveTo(centerX - (conicalTop / 3), centerY + 8);
    	labelContext.lineTo(centerX - (conicalTop / 3), (centerY + 8) - height);
      	labelContext.strokeStyle = "#FF0000";
  		labelContext.stroke();
  		labelContext.closePath();
      
      	labelContext.strokeStyle = "#000000";
    }
  
   if (lampShadeShape == "Duplex") {
      
      labelContext.font = "14px Arial";
  	  labelContext.fillStyle = "#000000";
  	  labelContext.textAlign = "center";
	  labelContext.fillText("Side View", centerX, ((centerY + 8) - height) - 20);
      
      if (conicalBottom > conicalTop) {
  	    labelContext.fillText("Top View", centerXB, (centerY - 15) - (conicalBottom / 2));
      }else {
        labelContext.fillText("Top View", centerXB, (centerY - 15) - (conicalTop / 2));
      }
      
      	var sideViewHeightLabel = (height / 2) + "cm";
  		labelContext.font = "12px Arial";
  		labelContext.fillStyle = "#FF0000";
  		labelContext.textAlign = "right";
		labelContext.fillText(sideViewHeightLabel, centerX - 90, (centerY + 24) - (height / 2) / 2);
     
     	labelContext.font = "12px Arial";
  		labelContext.fillStyle = "#FF0000";
      	labelContext.textAlign = "right";
      	labelContext.fillText("Height", centerX - 90, (centerY + 36) - (height / 2) / 2);
      	
      	labelContext.font = "12px Arial";
      	labelContext.fillStyle = "#000000";
        labelContext.textAlign = "left";
		var sideViewBottomFrameLabel = (conicalBottom / 2) + "cm";
  		labelContext.fillText(sideViewBottomFrameLabel, (centerX - 20) + (conicalBottom / 2), centerY + 25);
  		var sideViewTopFrameLabel = (conicalTop / 2) + "cm";
  		labelContext.fillText(sideViewTopFrameLabel, (centerX - 20) + (conicalTop / 2), centerY - height);
      
      	//calc hypotenuse
        var a = ((conicalBottom / 2) - (conicalTop / 2)) / 2;
        var h = height / 2;
        var c = (a * a) + (h * h); 
        hyp = Math.sqrt(c);
      
		labelContext.font = "12px Arial";
  		labelContext.fillStyle = "#0000FF";
      	labelContext.textAlign = "right";
        labelContext.fillText(hyp.toFixed(2) + "cm", centerX - 90, centerY - (height / 2) / 2);
      	labelContext.fillText("Hypotenuse", centerX - 90, (centerY + 12) - (height / 2) / 2);
      
      	labelContext.beginPath();
  		labelContext.moveTo((centerX - 5) - (conicalBottom / 2) , centerY + 8);
    	labelContext.lineTo((centerX - 5) -(conicalBottom / 2) , (centerY + 8) - height);
      	labelContext.strokeStyle = "#FF0000";
  		labelContext.stroke();
  		labelContext.closePath();
      
      	labelContext.strokeStyle = "#000000";
    }
  


 
  
  //FORM ELEMENTS ////////////////////////////////////////////
  //
 
  // LAMPSHADE SHAPE
  var lampShadeShapeEMAIL = document.getElementById('LampshadeType');
  lampShadeShapeEMAIL.value = lampShadeShape;
  
  //lamp or pendant etc.. 
  var lamporpendanttypeEMAIL = document.getElementById('lampOrPendantEMAIL');
  lamporpendanttypeEMAIL.value = lamporpendant; 
	
    
  
  //HEIGHT
  var heightEMAIL = document.getElementById('height');
  heightEMAIL.value = height / 2 + "cm";
  
  if (lampShadeShape == "Conical") {
  	var hypotenuseEMAIL = document.getElementById('hypotenuse');
  	hypotenuseEMAIL.value = hyp.toFixed(2) + "cm";
  }
  
  //Frame Sizes:
  var topFrameSizeEMAIL = document.getElementById('topFrameSize');
  var bottomFrameSizeEMAIL = document.getElementById('bottomFrameSize');
  
  if (lampShadeShape == "Round") {
   	 topFrameSizeEMAIL.value = (roundDiameter / 2) + "cm";
     bottomFrameSizeEMAIL.value = (roundDiameter / 2) + "cm";
  }
  
  if (lampShadeShape == "Conical") {
  	topFrameSizeEMAIL.value = (conicalTop / 2) + "cm";
    bottomFrameSizeEMAIL.value = (conicalBottom / 2) + "cm";
  }
  
  if (lampShadeShape == "Duplex") {
    topFrameSizeEMAIL.value = (conicalTop / 2) + "cm";
    bottomFrameSizeEMAIL.value = (conicalBottom / 2) + "cm";
    
    var carrierEMAIL = document.getElementById('carrierEMAIL');
    //Shade Carrier
    if (includeCarrier == true) {
      carrierEMAIL.value = carrierSizeLabel;
    } else {
      carrierEMAIL.value = "No Shade Carrier.";
    }
       
  }
  
  
  
  //DIFFUSER
  if (lamporpendant == "Pendant") {
    var diffuserEMAIL = document.getElementById('diffuserEMAIL');
    if (includeDiffuser == true) {
      diffuserEMAIL.value = "£ " + diffuserPrice + " " + diffuserSize; 
    } else {
      diffuserEMAIL.value = "none"; 
    }
  }
  
  
  
  //PRICE 
  var priceEMAIL = document.getElementById('perShadePrice');
  priceEMAIL.value = price.toFixed(2);
  
  //DESIGN NAME
  var designName = document.getElementById('designName');
  if (designBlurb) {
  	designName.value = designBlurb;
  }
  
  
  ///////////////////////////////////////////////////////////////////
  
}




function updateSummary() {
  //SUMMARY AREA  
  
  var shapeSummary = document.getElementById('shapeSummary');
  var sizeSummary = document.getElementById('sizeSummary');
  var heightSummary = document.getElementById('heightSummary');
  var orientationSummary = document.getElementById('orientationSummary');
  var priceSummary = document.getElementById('priceSummary');
  var subtotalSummary = document.getElementById('subtotalSummary');
  var diffuserSummary = document.getElementById('diffuserSummary');
  var carrierSummary = document.getElementById('carrierSummary');
  var designSummary = document.getElementById('designSummary');
  var designSummary2 = document.getElementById('designSummary2');
  //var designSummaryImage = document.getElementById('designSummaryImage');
  //var designSummaryImage2 = document.getElementById('designSummaryImage2');
  
  
  if (lampShadeShape == "Round") {
   	shapeSummary.innerHTML = "Currently you've picked a <strong>" + lampShadeShape + "</strong> Lampshade,"; 
    sizeSummary.innerHTML = "with a <strong>Diameter</strong> of " + (roundDiameter / 2) + "cm.";
    heightSummary.innerHTML = "Perpendicular <strong>Height</strong> of " + (height / 2) + "cm.";
    orientationSummary.innerHTML = "The Orientation will be for a <strong>" + lamporpendant + "</strong>. Compatible with any B22 & E27 Fittings";
  }
  
  if (lampShadeShape == "Conical") {
  	shapeSummary.innerHTML = "Currently you've picked a <strong>" + lampShadeShape + "</strong> Lampshade,"; 
  	sizeSummary.innerHTML = "with a <strong>top diameter of " + (conicalTop / 2) + "cm</strong> and a <strong>bottom diameter of " + (conicalBottom / 2) + "cm.</strong>";
  	heightSummary.innerHTML = "Perpendicular <strong>Height</strong> :<strong>" + (height / 2) + "cm.</strong>";
    var hypTemp = hyp.toFixed(2)
    heightSummary.innerHTML = "<strong>Perpendicular</strong> <strong>Height</strong> of <strong>" + (height / 2) + "cm</strong> and a <strong>Hypotenuse&#40;Slope&#41;</strong> of <strong>" + hypTemp + "cm.</strong>";
 	orientationSummary.innerHTML = "Orientation: <strong>" + lamporpendant + "</strong>. Compatible with B22 & E27 Fittings";
  }
  
  if (lampShadeShape == "Duplex"){
    shapeSummary.innerHTML = "Currently you've picked a <strong>" + lampShadeShape + "</strong> Lampshade,"; 
  	sizeSummary.innerHTML = "with a <strong>top diameter of " + (conicalTop / 2) + "cm</strong> and a <strong>bottom diameter of " + (conicalBottom / 2) + "cm.</strong>";
  	heightSummary.innerHTML = "Perpendicular <strong>Height</strong> :<strong>" + (height / 2) + "cm.</strong>";
    var hypTemp = hyp.toFixed(2)
    heightSummary.innerHTML = "<strong>Perpendicular</strong> <strong>Height</strong> of <strong>" + (height / 2) + "cm</strong> and a <strong>Hypotenuse&#40;Slope&#41;</strong> of <strong>" + hypTemp + "cm.</strong>";
 	orientationSummary.innerHTML = "Orientation: <strong>" + lamporpendant + "</strong>. Compatible with B22 & E27 Fittings";
  }
  
  if (includeDiffuser == true && lamporpendant == "Pendant") {
    diffuserSummary.innerHTML = "A <strong>diffuser</strong> will be included with your lampshade.";
  } else {
  	diffuserSummary.innerHTML = "";
  }
  
  if(includeCarrier == true && lampShadeShape == "Duplex"){
    carrierSummary.innerHTML = "A <strong>" + carrierSizeLabel + "</strong> shade carrier will be included with your lampshade."; 
  }else {
    carrierSummary.innerHTML = "";
  }
  
 if (designBlurb) {
    
  	designSummary.innerHTML = "You've Picked " + designBlurb;
  	designSummary2.innerHTML = "You've Picked " + designBlurb;

  }
  
  subtotalSummary.innerHTML = price.toFixed(2) + " inc VAT";
   
  priceSummary.innerHTML = price.toFixed(2) + " inc VAT";
  
  
}


function updateDesign(value) {
 
  var currentDesign = value;
  
  designBlurb = " "; 

  if(currentDesign == "F100") {
    designBlurb = "F100 ~ Zoo Animals"
  }

  if(currentDesign == "F110") {
    designBlurb = "F110 ~ William Morris Fruits Fabric"
  }

  if(currentDesign == "F120") {
    designBlurb = "F120 ~ Cherry Blossom Blues"
  }

  if(currentDesign == "F130") {
    designBlurb = "F130 ~ Beach Hut Fabric"
  }

  if(currentDesign == "B140") {
    designBlurb = "B140 ~ Batik Circles Hot Pink"
  }

  if(currentDesign == "B139") {
    designBlurb = "B139 ~ Coastline Marble"
  }

  if(currentDesign == "B138") {
    designBlurb = "B138 ~ Batik Leaf Sea Foam";
  }

  if(currentDesign == "B137") {
    designBlurb = "B137 ~ Butterfly Kaleidoscope Red";
  }

  if(currentDesign == "B136") {
    designBlurb = "B136 ~ Butterfly Kaleidoscope Black";
  }

  if(currentDesign == "B135") {
    designBlurb = "B135 ~ Gold Birds";
  }

  if(currentDesign == "B134") {
    designBlurb = "B134 ~ Sea Sparkle";
  }

  if(currentDesign == "B133") {
    designBlurb = "B133 ~ Atlas Marble";
  }

  if(currentDesign == "B132") {
    designBlurb = "B132 ~ Metallic Marble";
  }

  if(currentDesign == "B131") {
    designBlurb = "B131 ~ Soft Hearts Rose";
  }
  
  if(currentDesign == "B130") {
    designBlurb = "B130 ~ Soft Hearts Lavender";
  }

  if(currentDesign == "B129") {
    designBlurb = "B129 ~ Batik Peony Blue";
  }

  if(currentDesign == "B128") {
    designBlurb = "B128 ~ Batik Star Flower Yellow";
  }

  if(currentDesign == "B127") {
    designBlurb = "B127 ~ Batik Big Flower Green";
  }

  if(currentDesign == "B125") {
   	designBlurb = "B125 - Batik Leaf Teal"; 
  }

  if(currentDesign == "B126") {
   	designBlurb = "B126 - Batik Leaf Bright Green"; 
  }

  if(currentDesign == "B121") {
   	designBlurb = "B121 - Batik Tread Plate Lilac"; 
  }
  
  if(currentDesign == "B123") {
   	designBlurb = "B123 - Batik Leaf Orange"; 
  }
  
  if(currentDesign == "B124") {
   	designBlurb = "B124 - Batik Leaf Grey"; 
  }
  
  if(currentDesign == "P45") {
   	designBlurb = "P45 - Embroidered Aqua"; 
  }
  
  if(currentDesign == "P46") {
   	designBlurb = "P46 - Embroidered Evening Blue"; 
  }
  
  if(currentDesign == "P47") {
   	designBlurb = "P47 - White Non Woven Fabric"; 
  }
  
  if(currentDesign == "P48") {
   	designBlurb = "P48 - Yellow Non Woven Fabric"; 
  }
  
  if(currentDesign == "P49") {
   	designBlurb = "P49 - Peach Non Woven Fabric"; 
  }
  
  if(currentDesign == "P50") {
   	designBlurb = "P50 - Green Non Woven Fabric"; 
  }
  
  if(currentDesign == "P51") {
   	designBlurb = "P51 - Blue Non Woven Fabric"; 
  }
  
  if(currentDesign == "W09") {
   	designBlurb = "W09 - Peach Hills Washi"; 
  }
  
  if(currentDesign == "B119") {
    designBlurb = "B119 - Batik Peony Grey.";
  }
  
  if(currentDesign == "B120") {
    designBlurb = "B120 - Batik Peony Yellow.";
  }
  
  if(currentDesign == "B118") {
    designBlurb = "B118 - Batik Peony Red.";
  }
  
  if(currentDesign == "B117") {
    designBlurb = "B117 - Batik Lime Leaf.";
  }
  
  if(currentDesign == "B108") {
    designBlurb = "Flower of Life.";
  }
  
  if(currentDesign == "B112") {
    designBlurb = "B112 - Batik Lava.";
  }
  
  if(currentDesign == "B113") {
    designBlurb = "B113 - Batik Ocean.";
  }
  
  if(currentDesign == "B114") {
    designBlurb = "B114 - Batik Canopy.";
  }
  
  if(currentDesign == "B115") {
    designBlurb = "B115 - Batik Salt Lake.";
  }
  
  if(currentDesign == "B111") {
    designBlurb = "B111 - Batik Leaf Cyan.";
  }
  
  
  // BATIK 
  
    
  //MULTI SQUARE
  if (currentDesign == "P01") {
    designBlurb = "P01 - Batik Multi Square. ";
   
  } 
    
  // STRIPES
  
    if (currentDesign == "P04") {
    designBlurb = "P04 - Batik Stripes Pink. ";
    
    }
    
    if (currentDesign == "P05") {
    designBlurb = "P05 - Batik Stripes Blue. ";
    
    }
    
    if (currentDesign == "P06") {
    designBlurb = "P06 ~ Batik Stripes Autumn. ";
    
    }
    
    if (currentDesign == "P07") {
    designBlurb = "P07 ~ Batik Stripes Brown. ";
    
    }
    
    if (currentDesign == "P08") {
    designBlurb = "P08 ~ Batik Stripes Blue Grey. ";
    
    
    }
  
  
    
  // CIRCLES
  
  if (currentDesign == "P02") {
    designBlurb = "P02 ~ Batik Lime Circles. ";
  
  } 
    
  if (currentDesign == "P03") {
    designBlurb = "P03 ~ Batik Orange Circles. ";
    
  } 
  
  if (currentDesign == "P71") {
    designBlurb = "P71 ~ Batik Yellow Circles. ";
    }
    
  if (currentDesign == "P72") {
    designBlurb = "P72 ~ Batik Blue Circles. ";
    }
    
  if (currentDesign == "P73") {
    designBlurb = "P73 ~ Batik Cranberry Circles. ";
    }
    
  if (currentDesign == "P74") {
    designBlurb = "P74 ~ Batik Natural Circles. ";
  }
    
  if (currentDesign == "P83") {
    designBlurb = "P83 ~ Batik Red Circles. ";
    }
    
  
    
  // PEONY  
  if (currentDesign == "P09") {
    designBlurb = "P09 ~ Batik Peony on Natural. ";
  }
    
  // TREAD PLATE
  
    

    
    
  if (currentDesign == "P10") {
    designBlurb = "P10 ~ Batik Tread Plate Natural. ";
   }
    
    
  if (currentDesign == "P11") {
    designBlurb = "P11 ~ Batik Tread Plate Black. ";
     
  }
    
  if (currentDesign == "P12") {
    designBlurb = "P12 ~ Batik Tread Plate Brown. ";
    
  }
    
    
  if (currentDesign == "P14") {
    designBlurb = "P14 ~ Batik Tread Plate Cranberry. ";
    
  }
    
  if (currentDesign == "P88") {
    designBlurb = "P88 ~ Batik Tread Plate Grey. ";
    
  }
    
  if (currentDesign == "P89") {
    designBlurb = "P89 ~ Batik Tread Plate Yellow. ";
    
  }
    
  if (currentDesign == "P90") {
    designBlurb = "P90 ~ Batik Tread Plate Red. ";
    
  }
  
  if (currentDesign == "P91") {
    designBlurb = "P91 ~ Batik Tread Plate Orange. ";
    
  }
    
  if (currentDesign == "P96") {
    designBlurb = "P96 ~ Batik Tread Plate Green. ";
    
  }
  
  if (currentDesign == "P93") {
    designBlurb = "P93 ~ Batik Tread Plate Seafoam. ";
    
  }
    
  
    
  // BIG FLOWERS
  
  if (currentDesign == "P17") {
    designBlurb = "P17 ~ Batik Big Flower on Natural. ";
    
  }  
    
  if (currentDesign == "P18") {
  	designBlurb = "P18 ~ Batik Big Flower on Red";
  }
    
  if (currentDesign == "P19") {
    designBlurb = "P19 ~ Batik Big Flower on Rainforest. ";
    
  }
    
  if (currentDesign == "P20") {
    designBlurb = "P20 ~ Batik Big Flower on Brown. ";
    
  }
    
  if (currentDesign == "P21") {
    designBlurb = "P21 ~ Batik Big Flower on Lilac. ";
    
  }
    
  if (currentDesign == "P22") {
    designBlurb = "P22 ~ Batik Big Flower on Hot Pink. ";
    
  }
    
  if (currentDesign == "P23") {
    designBlurb = "P23 ~ Batik Big Flower on Teal. ";
  }
    
  if (currentDesign == "P24") {
    designBlurb = "P24 ~ Batik Big Flower on Black. ";
  }
    
  
    
  // BATIK LEAF
  
   if (currentDesign == "P28") {
    designBlurb = "P28 ~ Batik Leaf on Natural. ";

  } 
    
  if (currentDesign == "P29") {
    designBlurb = "P29 ~ Batik Leaf on Green. ";

  }
    
  if (currentDesign == "P30") {
    designBlurb = "P30 ~ Batik Leaf on Red. ";

  }
    
  if (currentDesign == "P31") {
    designBlurb = "P31 ~ Batik Leaf on Blue. ";

  }
    
  if (currentDesign == "P66") {
    designBlurb = "P66 ~ Batik Leaf on Camel. ";
 
  }
    
  if (currentDesign == "P67") {
    designBlurb = "P67 ~ Batik Leaf on Pink. ";

  }
  
  if (currentDesign == "P68") {
    designBlurb = "P68 ~ Batik Leaf on Purple. ";

  }
    
  if (currentDesign == "B107") {
    designBlurb = "B107 ~ Batik Leaf on Yellow. ";

  }
    
  
    
  // BATIK FLOWER
  
  if (currentDesign == "P35") {
    designBlurb = "P35 ~ Batik Multi Flower on Natural. ";

  }
  
  if (currentDesign == "P36") {
    designBlurb = "P36 ~ Batik Multi Flower on Pink. ";

  }
    
  if (currentDesign == "P38") {
    designBlurb = "P38 ~ Batik Multi Flower on Purple. ";

  }
      
  
    
  // BATIK STAR FLOWER
  
  if (currentDesign == "P75") {
    designBlurb = "P75 ~ Batik Star Flower Natural. ";

  }
    
  if (currentDesign == "P76") {
    designBlurb = "P76 ~ Batik Star Flower Red. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/151217_15_d0a6c8ac-601a-44db-b820-0cedb52a88d4_300x.jpg?v=1572052679";
    designSummaryImageSrc2 = "";
  }
  
  if (currentDesign == "P77") {
    designBlurb = "P77 ~ Batik Star Flower Grey. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--166_300x.jpg?v=1584008283";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--167_300x.jpg?v=1584008283";
  }
    
  if (currentDesign == "P80") {
    designBlurb = "P80 ~ Batik Star Flower Mint Green. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/files/Beaumaris-Shoot_06-2020__19_300x.jpg?v=1592482121";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/files/Beaumaris-Shoot_06-2020__21_300x.jpg?v=1592482121";
  }
    
  if (currentDesign == "P94") {
    designBlurb = "P94 - Batik Star Flower on Orange. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/files/March-Shoot--146_300x.jpg?v=1588030865";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/files/March-Shoot--147_300x.jpg?v=1588030975";
  }
    
  
  
  // BATIK DOTS
  
  	if (currentDesign == "P78") {
    designBlurb = "P78 ~ Batik Dots on Grey. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/Tall-Drum-Lamp-Shade-Batik-Dots-Pendant_300x300.jpg?v=1572052021";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/Table-Lamp_Imbue-Lighting---16_300x.jpg?v=1572053492";
  }
    
  if (currentDesign == "P79") {
    designBlurb = "P79 ~ Batik Dots on Purple. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/files/Beaumaris-Shoot_06-2020__17__LIVE_300x.jpg?v=1592482269";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/files/Beaumaris-Shoot_06-2020__18__LIVE_300x.jpg?v=1592482270";
  }
    
  if (currentDesign == "P84") {
    designBlurb = "P84 ~ Batik Dots on Red. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/Sapele_Table_Lamp_Drum-Lamp-Shade_Red-Dots_Lit_300x.jpg?v=1572053654";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/Sapele_Table_Lamp_Drum-Lamp-Shade_Red-Dots_300x.jpg?v=1572053654";
  }
    
  if (currentDesign == "P85") {
    designBlurb = "P85 ~ Batik Dots on Natural. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--56_300x.jpg?v=1584014987";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--57_300x.jpg?v=1584014987";
  }
    
  if (currentDesign == "P86") {
    designBlurb = "P86 ~ Batik Dots on Yellow. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--100_300x.jpg?v=1584012921";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--101_300x.jpg?v=1584012921";
  }
    
  if (currentDesign == "P87") {
    designBlurb = "P87 ~ Batik Dots on Green. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/files/Beaumaris-Shoot_06-2020__15_300x.jpg?v=1592482326";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/files/Beaumaris-Shoot_06-2020__16_300x.jpg?v=1592482326";
  }
    
  if (currentDesign == "P97") {
    designBlurb = "P97 ~ Batik Dots on Cyan. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--168_300x.jpg?v=1584008221";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/Drum-Lamp-Shade_Cyan-Dots_Side_300x.jpg?v=1584008221";
  }
    
  if (currentDesign == "B110") {
    designBlurb = "B110 ~ Batik Dots on Orange. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/files/Batik-Orange-Dots_ImbueLighting_14_300x300.jpg?v=1606177356";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/files/Batik-Orange-Dots_ImbueLighting_13_300x300.jpg?v=1606177356";
  } 
    
  
  
   
  
  
  
  // PETALS 
  
  if (currentDesign == "P32") {
    designBlurb = "P32 ~ Marigold Petals on Natural Lokta. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--68_300x.jpg?v=1584014623";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--69_300x.jpg?v=1584014623";
  } 
  
  if (currentDesign == "P33") {
    designBlurb = "P33 ~ Rose Petals on Natural Lokta. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/files/P33-Rose-Petals_300x.jpg?v=1587953380";
  } 
  
  if (currentDesign == "P34") {
    designBlurb = "P34 ~ Cornflower Petals on Natural Lokta. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--111_300x.jpg?v=1584012577";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/files/Tall-Square-Lamp-Shade-Cornflower-Petals_300x.jpg?v=1588029514";
  } 
  
  if (currentDesign == "P95") {
    designBlurb = "P95 - Little Leaves. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/P95_Little_Leaves_02_e6ae8fed-3c9d-494f-beef-ab491f24a787_300x.jpg?v=1584014432";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/P95_Little_Leaves_01_59116642-6c46-41b0-b4d6-f48c2ddb5dc0_300x.jpg?v=1584014432";
  } 
  

  
  // SCREEN
  
  
    

    
  if (currentDesign == "W01") {
    designBlurb = "W01 ~ Red Daisies. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--172_300x.jpg?v=1584013127";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--173_300x.jpg?v=1584013127";
  } 
  
  if (currentDesign == "W02") {
    designBlurb = "W02 ~ Pink/Grey Blossom Yuzen Washi. ";
  }
  
  if (currentDesign == "W03") {
    designBlurb = "W03 ~ Gold Waves on Greys. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--40_300x.jpg?v=1584017494";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--41_300x.jpg?v=1584017494";
  } 
  
  if (currentDesign == "W04") {
    designBlurb = "W04 ~ Pink Hills Yuzen Washi. ";
  }
  
  if (currentDesign == "W05") {
    designBlurb = "W05 ~ Cranes Yuzen Washi. ";
  }
  
  if (currentDesign == "W06") {
    designBlurb = "W06 ~ Kyoto. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--11_300x.jpg?v=1584017755";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--12_300x.jpg?v=1584017755";
  } 
  
  if (currentDesign == "W07") {
    designBlurb = "W07 ~ Peach Daisies. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/Washi-Paper-Lamp-Shade_66_300x.jpg?v=1582730456";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/Washi-Paper-Lamp-Shade_72_300x.jpg?v=1582730456";
  } 
    
  if (currentDesign == "W08") {
    designBlurb = "W08 ~ Lily Pond. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/files/Lily-Pond-Washi-Lampshade-Drum-25cmX25cm_300x.jpg?v=1605030674";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/files/Lily-Pond-Washi-Lampshade-Drum-25cmX25cm_Lit_300x.jpg?v=1605030676";
  } 
    
  if (currentDesign == "P40") {
    designBlurb = "P40 ~ Gold Fish Screen Print on Natural Lokta. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/Round-Sapele-Table-Lamp_15x30-GoldFish-Drum-Lamp-Shade_300x.jpg?v=1572053492";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/files/Oval-Lamp-Shade-Gold-Fish-Screen-Print-on-Natural-Lokta-Hadnmade-in-the-UK_300x.jpg?v=1587999335";
  } 
  
  if (currentDesign == "P41") {
    designBlurb = "P41 - Oriental Birds. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/P41-Oriental-Birds_Lit_5c4dea1b-fe9c-403d-886e-cd013db415d4_300x.jpg?v=1572053692";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/P41-Oriental-Birds_unlit_0b7e838e-96c9-49e5-9018-30cba5ab460d_300x.jpg?v=1572053692";
  }
  
  if (currentDesign == "P42") {
    designBlurb = "P42 ~ Bees Screen Print on Natural Lokta. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/Large-Free-Standing_Lamp_Bees_Lit_300x.jpg?v=1579867600";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--10_300x.jpg?v=1584017830";
  }
  
  if (currentDesign == "P69") {
    designBlurb = "P69 ~ Garden Gold on Natural. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--130_300x.jpg?v=1584010602";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--131_300x.jpg?v=1584010602";
  }
  
  if (currentDesign == "B102") {
    designBlurb = "B102 - Black Feathers. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/Imbue-Lighting_Lamp-Shade_P102-Black-Feather_02_d5c7bfc6-ce80-424b-8ebe-6acfb389823b_300x.jpg?v=1572053696";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/Imbue-Lighting_Lamp-Shade_P102-Black-Feather_04_57c12f55-8817-4756-972c-3112ea9940ef_300x.jpg?v=1572053696";
  }
  
  
  // RESISTANCE DYED
  
  if (currentDesign == "P25") {
    designBlurb = "P25 ~ Resistance Dyed Pink Fern. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/files/Beaumaris-Shoot_06-2020__31_300x.jpg?v=1592482405";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/files/Beaumaris-Shoot_06-2020__30_300x.jpg?v=1592482406";
  } 
  
  if (currentDesign == "P26") {
    designBlurb = "P26 ~ Resistance Dyed Brown Fern. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/161217_50_300x.jpg?v=1572051997";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/files/Lamp-Shade-30cm-x-20cm-Brown-Fern-handmade-Close-Up_300x.jpg?v=1588023664";
  }
  
  if (currentDesign == "P27") {
    designBlurb = "P27 ~ Resistance Dyed Green Fern. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/Large-Free-Standing_Lamp_Green-Fern_Lit_300x.jpg?v=1579867550";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/Large-Free-Standing_Lamp_Green-Fern_300x.jpg?v=1579867550";
  }
  
  if (currentDesign == "P99") {
    designBlurb = "P99 - Resistance Dyed Teal Bamboo. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--120_300x.jpg?v=1584011078";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--121_300x.jpg?v=1584011078";
  }
    
  if (currentDesign == "B106") {
    designBlurb = "B106 ~ Resistance Dyed Teal Fern. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/Drum-Floor-Lamp_15_300x300.jpg?v=1603792219";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/Drum-Floor-Lamp_16_300x300.jpg?v=1603792219";
  }
    
  if (currentDesign == "P39") {
    designBlurb = "P39 - Polka Dots on Natural Lokta. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/1024141432_300x.jpg?v=1572051868";
    designSummaryImageSrc2 = "";
  }
    
  if (currentDesign == "P43") {
    designBlurb = "P43 - Embroidered Flowers on White. ";
    designSummaryImageSrc = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--48_300x.jpg?v=1584016105";
    designSummaryImageSrc2 = "https://cdn.shopify.com/s/files/1/2637/4452/products/March-Shoot--49_300x.jpg?v=1584016105";
  }
    
  
  
  
  
  
  
  updateShade();
  
}